import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Sidebar, AppMain, Navbar } from './components';
import { mapGetters } from 'vuex';
import Watermark from '@/util/watermark';
import layoutTap from './components/layout-taps';
import Pagination from '@/components/pagination';
import expireDialog from 'util/expire-dialog';
import { getCompletedTaskList, getPendingTaskList } from '@/api/payroll';
export default {
  name: 'Layout',
  components: {
    Sidebar: Sidebar,
    AppMain: AppMain,
    Navbar: Navbar,
    layoutTap: layoutTap,
    Pagination: Pagination
  },
  data: function data() {
    return {
      slideTimeOut: false,
      isShowDia: false,
      downloadVisible: false,
      activeName: '1',
      downloadTask: {
        list: [],
        page: 1,
        page_size: 10
      },
      downloadPendingTask: {
        list: [],
        page: 1,
        total: 0,
        page_size: 10
      },
      baseInfo: this.$s.get('userInfo')
    };
  },
  created: function created() {
    // 获取水印
    if (Number(this.company_info.watermark)) {
      // 是否开启水印
      // eslint-disable-next-line no-new
      new Watermark({
        text: "".concat(this.baseInfo.name, " ").concat(this.baseInfo.mobile.slice(-4))
      });
    }
  },
  mounted: function mounted() {
    expireDialog({
      expire_time: this.company_info.expire_time,
      audit_status: this.company_info.audit_status
    }, this.$t);
    this.resetDocumentClientHeight();
    this.initOpend();
  },
  // mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    fixedHeader: function fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }, mapGetters(['routes', 'sidebar'])), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    // 计算宽度
    navWidth: function navWidth() {
      return this.classObj.openSidebar ? 216 : 48;
    },
    // taps style
    tapsStyle: function tapsStyle() {
      var navWidth = this.navWidth;
      return {
        left: "".concat(navWidth, "px"),
        width: "calc(100% - ".concat(navWidth, "px)")
      };
    },
    company_info: function company_info(vm) {
      return vm.$store.state.user.company_info;
    }
  }),
  methods: {
    onDownload: function onDownload() {
      // 异步下载列表
      this.downloadVisible = true;
      this.handleClick();
    },
    handleClick: function handleClick() {
      var _this = this;
      // 进行中 已完成
      if (this.activeName === '1') {
        getPendingTaskList().then(function (res) {
          if (res && res.code === 1) _this.downloadTask.list = res.data;
        });
      } else {
        getCompletedTaskList({
          page: this.downloadPendingTask.page,
          page_size: this.downloadPendingTask.page_size
        }).then(function (res) {
          if (res && res.code === 1) {
            _this.downloadPendingTask.list = res.data.data;
            _this.downloadPendingTask.total = res.data.count;
          }
        });
      }
    },
    handleCheck: function handleCheck(item) {
      // 查看
      if (item.relation_type === '1') {
        this.$router.push({
          path: '/payroll/wageSalary/' + item.params.sub_id
        });
      }
      this.closeDownload();
    },
    handleDownload: function handleDownload(item) {
      // 下载相关内容
      if (item.result && item.result.length) {
        item.result.forEach(function (url) {
          window.open(url);
        });
      }
    },
    closeDownload: function closeDownload() {
      // 关闭下载弹窗
      this.downloadVisible = false;
      this.activeName = '1';
      this.downloadPendingTask.page = 1;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      // 修改分页
      this.$refs.downloadList.scrollTop = 0;
      this.downloadPendingTask.page = val;
      this.handleClick();
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    resetDocumentClientHeight: function resetDocumentClientHeight() {
      var _this2 = this;
      this.$store.commit('settings/updateContentViewHeight', window.innerHeight - 170);
      window.addEventListener('resize', this.$util.debounce(function () {
        _this2.$store.commit('settings/updateContentViewHeight', window.innerHeight - 170);
        _this2.initOpend();
      }, 500));
    },
    // 初始化菜单状态
    initOpend: function initOpend() {
      try {
        var globalWidth = document.body.getBoundingClientRect().width;
        this.$store.state.app.sidebar.opened = globalWidth > 1000;
      } catch (error) {}
    }
  }
};